import { render, staticRenderFns } from "./ReceiveAQuote.vue?vue&type=template&id=2f9b504b&scoped=true"
import script from "./ReceiveAQuote.vue?vue&type=script&lang=js"
export * from "./ReceiveAQuote.vue?vue&type=script&lang=js"
import style0 from "./ReceiveAQuote.vue?vue&type=style&index=0&id=2f9b504b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9b504b",
  null
  
)

export default component.exports